/* @flow */

import type {ListItem, LeadCardComponentLeadProps} from '../types';
import {formatLeadValue} from '../utils/format-lead-values';

/**
 * Helper function to take a LeadListItem and translate its properties
 * to the props expected for a LeadCard component.
 *
 * @param  {ListItem} listItem - Full list item model to translate to props
 * @return {Object}            - All the props a LeadCard needs to render itself
 */
export function listItemToLeadCardProps(listItem: ListItem): LeadCardComponentLeadProps {
    const getFormattedValue = () => {
        if (
            listItem.fields &&
            listItem.fields.value &&
            listItem.fields.value.formattedValue &&
            listItem.fields.value.formattedValue &&
            listItem.fields.value.formattedValue.value &&
            listItem.fields.value.formattedValue.prefix
        ) {
            return formatLeadValue(
                listItem.fields.value.formattedValue.value,
                listItem.fields.value.formattedValue.prefix
            );
        } else {
            return undefined;
        }
    };

    return {
        id: listItem.links.entity.id,
        leadName: listItem.primaryName,
        leadNumber: listItem.primaryInfo,
        leadStatus:
            listItem.fields &&
            listItem.fields.status &&
            listItem.fields.status.value &&
            listItem.fields.status.value.value,
        priority: listItem.priority,
        htmlUrl: listItem.htmlUrl,
        avatarUrl: listItem.avatarUrl,
        value: listItem.fields && listItem.fields.value && listItem.fields.value.value,
        formattedValue: getFormattedValue(),
        assignee: listItem.fields && listItem.fields.owner ? listItem.fields.owner.value : null,
        overdueDuration:
            listItem.fields && listItem.fields.overdueDuration
                ? listItem.fields.overdueDuration.value
                : null,
        relatedPerson: listItem.primaryContact,
        relatedCompany: listItem.primaryAccount,
    };
}
